import { memo } from "react";
import type { SvgProps } from "react-native-svg";
import Svg, { Path } from "react-native-svg";

const SvgMenu = (props: SvgProps) => (
  <Svg width={20} height={16} fill="none" {...props}>
    <Path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 12h16M1 6.5h16M1 1h16"
    />
  </Svg>
);
const Memo = memo(SvgMenu);
export default Memo;
